// Tracking
import { trackEcommerce } from 'dibs-tracking';
import { graphql } from 'react-relay';
import get from 'lodash.get';

const getProducts = (items, listType) => {
    return items.map(item => {
        return {
            dimension83: item.contemporaryTrackingString,
            id: item.serviceId,
            name: item.title,
            category: item.categoryPath,
            brand: get(item, 'seller.serviceId'),
            price: get(item, 'pricing.retailPrice.amount'),
            position: item.index,
            list: listType,
        };
    });
};

export const trackImpressions = (items, listType) => {
    if (items.length) {
        const products = getProducts(items, listType);
        trackEcommerce({ type: 'productImpression', products });
    }
};

export const trackProductClick = (item, listType, index) => {
    const products = getProducts([Object.assign({ index }, item)], listType);
    trackEcommerce({ type: 'productClick', products, actionField: { list: listType } });
};

export const trackingHelpersItem = {
    item: graphql`
        fragment trackingHelpers_item on Item {
            contemporaryTrackingString
            categoryPath
            seller {
                serviceId
            }
            pricing {
                retailPrice {
                    amount
                }
            }
        }
    `,
};
